import { UPDATE_CREATOR } from '../actions';

export default function updateCreator({ creatorId }) {
  const action = {
    type: UPDATE_CREATOR,
    creatorId,
  };

  return action;
}
